// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"11fa82b1","455":"8508d4a2","977":"b41cea9e"}[chunkId] + ".chunk.js";
};